import React from 'react';
import { motion } from 'framer-motion';
import { Map, FileText, MessageSquare, Calendar, CheckCircle2 } from 'lucide-react';
export function MechanismSection() {
  return <section className="bg-brand-surface py-20 px-4 overflow-hidden" data-id="element-175">
      <div className="max-w-4xl mx-auto" data-id="element-176">
        {/* The Reveal */}
        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} className="text-center mb-16" data-id="element-177">
          <span className="text-brand-yellow font-display font-bold tracking-widest uppercase text-sm mb-2 block" data-id="element-178">
            La Solución
          </span>
          <h2 className="font-display text-5xl md:text-6xl font-bold text-white mb-6" data-id="element-179">
            El Mapa 3×3
          </h2>
          <p className="text-xl text-gray-300 max-w-2xl mx-auto" data-id="element-180">
            Este Libro Digital está diseñado para una persona real: con vida real, cansancio real, y urgencia real.
          </p>
        </motion.div>

        {/* The Formula */}
        <div className="grid md:grid-cols-3 gap-4 mb-16 text-center" data-id="element-181">
          <div className="bg-[#111] p-6 rounded-lg border border-gray-800" data-id="element-182">
            <div className="text-4xl font-bold text-brand-yellow mb-2" data-id="element-183">3</div>
            <div className="text-gray-300 font-medium" data-id="element-184">
              Habilidades Normales
            </div>
            <div className="text-sm text-gray-500 mt-1" data-id="element-185">(Lo que ya sabes)</div>
          </div>
          <div className="flex items-center justify-center text-gray-600 font-display text-2xl" data-id="element-186">
            ×
          </div>
          <div className="bg-[#111] p-6 rounded-lg border border-gray-800" data-id="element-187">
            <div className="text-4xl font-bold text-brand-yellow mb-2" data-id="element-188">3</div>
            <div className="text-gray-300 font-medium" data-id="element-189">Plataformas Rápidas</div>
            <div className="text-sm text-gray-500 mt-1" data-id="element-190">
              (Donde compran hoy)
            </div>
          </div>
        </div>

        {/* What's Included */}
        <div className="bg-[#111] rounded-2xl p-8 md:p-12 border border-brand-yellow/20 shadow-[0_0_40px_rgba(0,0,0,0.5)]" data-id="element-191">
          <h3 className="font-display text-3xl font-bold text-white mb-8 text-center" data-id="element-192">
            Lo que recibes dentro del Libro Digital:
          </h3>

          <div className="grid md:grid-cols-2 gap-8" data-id="element-193">
            <div className="space-y-6" data-id="element-194">
              <FeatureItem icon={<Map className="text-brand-yellow" data-id="element-196" />} title="El Método Mapa 3×3" desc="9 rutas listas (producto, servicio, digital simple). Tú eliges una." data-id="element-195" />
              <FeatureItem icon={<FileText className="text-brand-yellow" data-id="element-198" />} title="Plantillas de Publicación" desc="Título + descripción + fotos. Copiar y pegar." data-id="element-197" />
              <FeatureItem icon={<MessageSquare className="text-brand-yellow" data-id="element-200" />} title="Guiones de Venta" desc="Qué decir cuando preguntan precio, seguimiento y cierre." data-id="element-199" />
            </div>
            <div className="space-y-6" data-id="element-201">
              <FeatureItem icon={<Calendar className="text-brand-yellow" data-id="element-203" />} title="Plan Diario de 7 Días" desc="Paso a paso exacto. 30-60 minutos al día." data-id="element-202" />
              <FeatureItem icon={<CheckCircle2 className="text-brand-yellow" data-id="element-205" />} title="Manejo de Objeciones" desc="Respuestas para 'está caro', 'lo pienso', 'no confío'." data-id="element-204" />
              <FeatureItem icon={<CheckCircle2 className="text-brand-yellow" data-id="element-207" />} title="Rutina Semanal" desc="Cómo pasar de 1 venta a 5 ventas repitiendo el sistema." data-id="element-206" />
            </div>
          </div>
        </div>
      </div>
    </section>;
}
function FeatureItem({
  icon,
  title,
  desc
}: {
  icon: React.ReactNode;
  title: string;
  desc: string;
}) {
  return <div className="flex gap-4" data-id="element-208">
      <div className="mt-1 p-2 bg-brand-yellow/10 rounded-lg h-fit" data-id="element-209">{icon}</div>
      <div data-id="element-210">
        <h4 className="font-bold text-white text-lg" data-id="element-211">{title}</h4>
        <p className="text-gray-400 text-sm leading-relaxed" data-id="element-212">{desc}</p>
      </div>
    </div>;
}